import { useCachedQuery } from '../../../../hooks/useCachedQuery';

// Documentos livres do paciente (lista resumida, sem o conteúdo), com cache de leitura offline.
export function useDocuments(patientId) {
  const url = patientId ? `/patients/${patientId}/documents` : null;

  const { data, isLoading, isStale, updatedAt, error, refetch } = useCachedQuery(url);

  return {
    documents: data ?? [],
    isLoading,
    isStale,
    updatedAt,
    error,
    refetch,
  };
}
